
import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
import { isTokenExpired } from '../shared/utils/decodeJwt-util';
import { environment } from '@environments/environment';


export const httpInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const skipAuthForUrlPaths = [
    'v1/order/get/eta',
    'oauth2/v3/token/jwtforoktab2b'
  ];
  const shouldSkipAuth = skipAuthForUrlPaths.some(path => req.url.includes(path));
  const token = sessionStorage.getItem('apigee-jwt');
  const correlationId = uuidv4();
  const headers: any = {
    'Content-Type': 'application/json',
    'x-cah-api-guid': correlationId
  };

  if (!shouldSkipAuth) {
    if (isTokenExpired(token)) {
      // Redirect to login page
      globalThis.location.assign(environment.loginWebUrl);
      return new Observable<HttpEvent<any>>();
    }
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
  }

  const clonedRequest = req.clone({ setHeaders: headers });
  return next(clonedRequest);
};
